import React from 'react';
import { useStore } from '@thd-nucleus/experience-context';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { bool, number, string } from 'prop-types';
import { shouldHideATC } from './utils';
import { useDynamicRecs } from '../hooks/useDynamicRecs';
import { RecommendationsProductPodCarousel } from '../RecommendationsProductPodCarousel';
import { CompleteTheLookProductPodCarousel } from '../CompleteTheLookProductPodCarousel';

const SchemaBuilder = ({
  anchor,
  anchorImage,
  maxItems,
  requestKey,
  schemaName,
  showLoading,
  hideFavorites,
  hideFulfillment,
  collectionUrl
}) => {
  const { storeId, storeZip: zipCode } = useStore();
  const { data, metadata, productSkus, loading } = useDynamicRecs({
    schemaName,
    anchor,
    storeId,
    key: requestKey,
    manual: false
  });

  if (!productSkus.length > 0 && metadata) return null;

  return (
    <QueryProvider
      cacheKey={`${schemaName}-product-pods`}
      defaultVariables={{ storeId, zipCode }}
    >
      {
        schemaName === 'ctl' ? (
          <CompleteTheLookProductPodCarousel
            axiosLoading={loading}
            products={data?.products}
            collectionUrl={collectionUrl}
            hideFulfillment={hideFulfillment}
            itemClass="fixed-item"
            scheme={schemaName}
            showLoading={showLoading}
            requestKey={requestKey}
            skus={(productSkus || []).slice(0, maxItems)}
            title={metadata?.title}
          />
        )
          : (
            <RecommendationsProductPodCarousel
              anchorImage={anchorImage}
              axiosLoading={loading}
              hideATC={shouldHideATC(schemaName)}
              hideFavorites={hideFavorites}
              hideFulfillment={hideFulfillment}
              itemClass="fixed-item"
              scheme={schemaName}
              showLoading={showLoading}
              requestKey={requestKey}
              skus={(productSkus || []).slice(0, maxItems)}
              title={metadata?.title}
            />
          )
      }
    </QueryProvider>
  );
};

SchemaBuilder.propTypes = {
  anchor: string.isRequired,
  anchorImage: string,
  hideFavorites: bool,
  maxItems: number.isRequired,
  requestKey: string.isRequired,
  schemaName: string.isRequired,
  showLoading: bool,
  hideFulfillment: bool,
  collectionUrl: string
};

SchemaBuilder.defaultProps = {
  anchorImage: null,
  hideFavorites: true,
  hideFulfillment: true,
  showLoading: false,
  collectionUrl: null
};

export { SchemaBuilder };
